module.exports = __webpack_public_path__ + "static/media/DSCN9981_0.308c20ce.jpeg";